import Links from "./links"
import ConfigGenerator from "./config-generator"

import auth from "../auth/"

const configGenerator = new ConfigGenerator(auth);
const links = new Links(configGenerator);

export {links}
